module.exports = __webpack_public_path__ + "static/img/wczf.6fe4bd67.png";